"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-funding.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-funding.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardFundingContext = exports.FundingPaymentContext = void 0;
const amount_1 = require("../common/amount");
const external_card_1 = require("../common/external-card");
const wallet_provider_1 = require("../common/wallet-provider");
const protobufPackage = 'com.step.common.proto';
function createBaseFundingPaymentContext() {
    return {
        card: undefined,
        fundingSourceId: '',
        fundingSourceOwnerUserId: '',
        isP2p: false,
        fee: undefined,
        isAutoReload: false,
        isRecurring: false,
    };
}
exports.FundingPaymentContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.card)) {
            message.card = exports.CardFundingContext.fromJSON(object.card);
        }
        if (isSet(object.fundingSourceId)) {
            message.fundingSourceId = globalThis.String(object.fundingSourceId);
        }
        if (isSet(object.fundingSourceOwnerUserId)) {
            message.fundingSourceOwnerUserId = globalThis.String(object.fundingSourceOwnerUserId);
        }
        if (isSet(object.isP2p)) {
            message.isP2p = globalThis.Boolean(object.isP2p);
        }
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        if (isSet(object.isAutoReload)) {
            message.isAutoReload = globalThis.Boolean(object.isAutoReload);
        }
        if (isSet(object.isRecurring)) {
            message.isRecurring = globalThis.Boolean(object.isRecurring);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = exports.CardFundingContext.toJSON(message.card);
        }
        if (message.fundingSourceId !== undefined && message.fundingSourceId !== '') {
            obj.fundingSourceId = message.fundingSourceId;
        }
        if (message.fundingSourceOwnerUserId !== undefined && message.fundingSourceOwnerUserId !== '') {
            obj.fundingSourceOwnerUserId = message.fundingSourceOwnerUserId;
        }
        if (message.isP2p !== undefined && message.isP2p !== false) {
            obj.isP2p = message.isP2p;
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        if (message.isAutoReload !== undefined && message.isAutoReload !== false) {
            obj.isAutoReload = message.isAutoReload;
        }
        if (message.isRecurring !== undefined && message.isRecurring !== false) {
            obj.isRecurring = message.isRecurring;
        }
        return obj;
    },
    create(base) {
        return exports.FundingPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFundingPaymentContext();
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardFundingContext.fromPartial(object.card)
            : undefined;
        message.fundingSourceId = object.fundingSourceId ?? '';
        message.fundingSourceOwnerUserId = object.fundingSourceOwnerUserId ?? '';
        message.isP2p = object.isP2p ?? false;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        message.isAutoReload = object.isAutoReload ?? false;
        message.isRecurring = object.isRecurring ?? false;
        return message;
    },
};
function createBaseCardFundingContext() {
    return {
        panSuffix: '',
        network: '',
        cardType: external_card_1.ExternalCardType.INVALID_FUNDING_CARD_TYPE,
        walletProvider: wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER,
        fingerprint: '',
        entryMethod: external_card_1.ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD,
    };
}
exports.CardFundingContext = {
    fromJSON(object) {
        const message = {
            panSuffix: isSet(object.panSuffix) ? globalThis.String(object.panSuffix) : '',
            network: isSet(object.network) ? globalThis.String(object.network) : '',
            cardType: isSet(object.cardType)
                ? (0, external_card_1.externalCardTypeFromJSON)(object.cardType)
                : external_card_1.ExternalCardType.INVALID_FUNDING_CARD_TYPE,
            walletProvider: isSet(object.walletProvider)
                ? (0, wallet_provider_1.walletProviderFromJSON)(object.walletProvider)
                : wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER,
            entryMethod: isSet(object.entryMethod)
                ? (0, external_card_1.externalCardEntryMethodFromJSON)(object.entryMethod)
                : external_card_1.ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD,
        };
        if (isSet(object.fingerprint)) {
            message.fingerprint = globalThis.String(object.fingerprint);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.panSuffix !== '') {
            obj.panSuffix = message.panSuffix;
        }
        if (message.network !== '') {
            obj.network = message.network;
        }
        if (message.cardType !== external_card_1.ExternalCardType.INVALID_FUNDING_CARD_TYPE) {
            obj.cardType = (0, external_card_1.externalCardTypeToJSON)(message.cardType);
        }
        if (message.walletProvider !== wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER) {
            obj.walletProvider = (0, wallet_provider_1.walletProviderToJSON)(message.walletProvider);
        }
        if (message.fingerprint !== undefined && message.fingerprint !== '') {
            obj.fingerprint = message.fingerprint;
        }
        if (message.entryMethod !== external_card_1.ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD) {
            obj.entryMethod = (0, external_card_1.externalCardEntryMethodToJSON)(message.entryMethod);
        }
        return obj;
    },
    create(base) {
        return exports.CardFundingContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardFundingContext();
        message.panSuffix = object.panSuffix ?? '';
        message.network = object.network ?? '';
        message.cardType = object.cardType ?? external_card_1.ExternalCardType.INVALID_FUNDING_CARD_TYPE;
        message.walletProvider = object.walletProvider ?? wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER;
        message.fingerprint = object.fingerprint ?? '';
        message.entryMethod = object.entryMethod ??
            external_card_1.ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-funding.js.map